import { t } from 'i18next'

export const CONFIRMATION_USER_MESSAGE_EMAIL_EN = `Hello {{new_user}},

It's A pleasure to have you on board!

We added you as a user on EyesOn Asset, our Smart Audit System. You will be able to see all audits authorized for your profile from your company in our system.

1.User Profile:

Your current profile is: {{profile}}


2.User initial credentials:

Please click here for your first login: eyesonasset.com

login: {{login}}

password: {{password}}


3.Security information:

You know data and information protection is crucial in our business. The system has a built in Multi Factor Authentication (MFA), upon each login attempt it will send to your email a PIN, you will need it to login.

If this is your first login or you are resetting your password, it will ask you a new password - ATTENTION!! It needs to be at least 8 characters long, have at least 1 number, 1 caps letter, 1 special character. You can not use the last 3 passwords you've had with us.

If you do not login the system for 60 days your user will move to inactive, and you will have to request to your company manager or to eyeson staff to reset your user credentials.

After logging in:

a) If you stay more than 1 hour without any activity in the system, Karen, our System Management Manager and beloved AI will log you off.

b) if you close the browser window, Karen, our System Management Manager and beloved AI will log you off.

c) You can not have multiple instances of the system opened at the same time, Karen would not allow it.

3.Android APP

We have the mobile app available for download at Google Play Store: https://play.google.com/store/apps/details?id=com.anonymous.eyesonapp&pcampaignid=web_share

If you have an android cellphone/tablet, you can go to the Google play store and download the EyesOn Asset app, log in with the same credentials you have for the web application. 

ATTENTION!: The app currently only works if you have internet access.

a) You will see the list of audits you are authorized to see for your company.

b) Click in the Audit you want to work on, the physical checklist will show up.

c) if you are the auditor in charge of the audit, click in each section and follow the instructions to add the photos:
           i) You can use the app to take the pictures or you can add pictures from your gallery.

           ii) If you use the app to take the picture, make sure you do it in the vertical position, otherwise the picture will show up rotated.

           iii) for close ups and horizontal pictures we recommend you use your cellphone camera, and then add it from the gallery into the app.

ATTENTION!: If you are not the auditor responsible for the physical inspection, you can still see the report being populated, but PLEASE, do not add any picture or information yourself.

4.Help/Support

Zeh Quick Answer is our Chief Answering Officer and our most valued AI. He is there to provide you with the best answer we have to any of your doubts about the system (I would not rely in Zeh's answers for more philosophical stuff).

If you have any questions or doubts you can click on the top right of the web application - Contact Zeh! - and send him your bug, doubt or suggestion. You can also (I strongly recommend you doing it) add +1 805-912-8428 to your WhatsApp.

Of course, if nothing works the way you think it should work, you can always reach Shailon Ian, at shailon@vinciaero.com or on his whatsapp +55 11 944720605. Shailon is the CEO of Mandatech and he is not a bot or an AI.


5. Terms of Service and Privacy policy

At any time you can read our Terms of Service (https://www.eyesonasset.com/terms) and our Privacy policy (https://www.eyesonasset.com/privacy)

By logging in for the first time you accept both.

Best regards.`

export const CONFIRMATION_USER_MESSAGE_EMAIL_BR = `Olá {{new_user}},

É um prazer tê-la conosco!

Nós a adicionamos como usuário(a) no EyesOn Asset, nosso Sistema de Auditoria Inteligente. Você poderá ver todas as auditorias autorizadas para o seu perfil da sua empresa em nosso sistema.

1. Perfil do Usuário: 

Seu perfil é: {{profile}}


2. Credenciais iniciais do usuário: 

Por favor, clique aqui para seu primeiro login: eyesonasset.com 

login: {{login}}

senha: {{password}}


3. Informações de segurança: 

Você sabe que a proteção de dados e informações é crucial em nosso negócio. O sistema possui uma Autenticação Multi-Fator (MFA) integrada. A cada tentativa de login, será enviado um PIN para o seu e-mail, que você precisará para entrar no sistema. 

Se este for o seu primeiro login ou se você estiver redefinindo sua senha, será solicitado que você crie uma nova senha. ATENÇÃO! Ela precisa ter pelo menos 8 caracteres, incluindo pelo menos 1 número, 1 letra maiúscula e 1 caractere especial. Você não pode usar nenhuma das últimas 3 senhas que você usou conosco. 

Se você não acessar o sistema por 60 dias, seu usuário será movido para inativo, e você precisará solicitar ao gestor da sua empresa ou à equipe do EyesOn para redefinir suas credenciais de usuário. 

Após o login: 

a) Se você ficar mais de 1 hora sem qualquer atividade no sistema, Karen, nossa Gerente de Gestão de Sistemas e querida IA, irá desconectá-la. 

b) Se você fechar a janela do navegador, Karen, nossa Gerente de Gestão de Sistemas e querida IA, irá desconectá-la. 

c) Você não pode ter múltiplas instâncias do sistema abertas ao mesmo tempo, Karen não permitiria isso.

APP para Android Temos o aplicativo móvel disponível para download na Google Play Store. 

Procure por EyesOn Asset Se você tiver um celular/tablet Android, pode ir à Google Play Store e baixar o aplicativo EyesOn Asset, fazendo login com as mesmas credenciais que você usa para a aplicação web. 

ATENÇÃO!: O aplicativo atualmente só funciona se você tiver acesso à internet. 

a) Você verá a lista de auditorias que está autorizada a ver para sua empresa. 

b) Clique na auditoria em que deseja trabalhar, a lista de verificação física aparecerá. 

c) Se você for a auditora responsável pela auditoria, clique em cada seção e siga as instruções para adicionar as fotos: 

            i) Você pode usar o aplicativo para tirar as fotos ou pode adicionar fotos da sua galeria. 
            
            ii) Se usar o aplicativo para tirar a foto, certifique-se de fazê-lo na posição vertical, caso contrário, a foto aparecerá girada. 
            
            iii) Para close-ups e fotos horizontais, recomendamos que você use a câmera do seu celular e depois adicione da galeria ao aplicativo. Para mais informações sobre como usar o aplicativo, acesse: (link de instruções do app) 
            
ATENÇÃO!: Se você não for a auditora responsável pela inspeção física, ainda poderá ver o relatório sendo preenchido, mas POR FAVOR, não adicione nenhuma foto ou informação por conta própria.

Idioma: Você pode escolher o idioma dos menus do sistema. Na aplicação web, vá para o canto superior direito, você verá uma pequena seta para baixo, ao lado das informações do "Meu Perfil". Clique na seta e escolha a bandeira do idioma que deseja que o sistema use. 

ATENÇÃO! As listas de verificação e itens da lista permanecerão no idioma em que foram criados pela primeira vez.


4. Ajuda/Suporte:  Zeh Quick Answer é nosso Diretor de Respostas e nossa IA mais valorizada. Ele está lá para fornecer a melhor resposta que temos para qualquer dúvida sua sobre o sistema (não confie nas respostas de Zeh para assuntos mais filosóficos). 

Se você tiver qualquer pergunta ou dúvida, pode clicar no canto superior direito da aplicação web - Contate Zeh! ou Centro de Ajuda - e enviar seu bug, dúvida ou sugestão. Você também pode (eu recomendo fortemente que faça isso) adicionar o número +1 805-912-8428 ao seu WhatsApp. 

Claro, se nada funcionar do jeito que você acha que deveria funcionar, você sempre pode entrar em contato com Shailon Ian, pelo e-mail shailon@vinciaero.com ou pelo WhatsApp +55 11 944720605. Shailon é o CEO da Mandatech e ele não é um robô ou uma IA.


5. Termos de Serviço e Política de Privacidade 

A qualquer momento, você pode encontrar um link para nossos Termos de Serviço e nossa Política de Privacidade no canto inferior direito da página de login. Ao fazer login pela primeira vez, você aceita ambos.

Comprimentos.`

export const CONFIRMATION_USER_MESSAGE_EMAIL_ES = `Hola {{new_user}}, 

¡Es un placer tenerlo con nosotros! Lo hemos agregado como usuario en EyesOn Asset, nuestro Sistema de Auditoría Inteligente. A través de su perfil, podrá visualizar todas las auditorías autorizadas para su empresa en nuestro sistema.

Perfil del usuario:
Su perfil actual es: {{profile}}

Credenciales iniciales del usuario: 

Por favor, haga clic aquí para su primer inicio de sesión:
eyesonasset.com 

Login: {{login}}
Contraseña: {{password}}

Este acceso ha sido autorizado por uno de nuestros clientes para que pueda responder a las discrepancias encontradas durante la auditoría de una de sus aeronaves. En caso de necesitar asistencia, puede enviar un correo electrónico a edgar@mandatech.com.br, y él programará una capacitación sobre el uso del sistema.

Información de seguridad:

La protección de datos e información es crucial en nuestro negocio. El sistema cuenta con Autenticación Multifactor (MFA). En cada intento de inicio de sesión, se enviará un PIN a su correo electrónico, el cual necesitará para acceder al sistema.

Si este es su primer inicio de sesión o está restableciendo su contraseña, se le solicitará que cree una nueva.
¡Atención! La nueva contraseña debe tener al menos 8 caracteres, incluyendo al menos 1 número, 1 letra mayúscula y 1 carácter especial. No podrá reutilizar ninguna de las últimas 3 contraseñas.

Si no accede al sistema durante 60 días, su usuario será desactivado, y deberá solicitar al gestor de su empresa o al equipo de EyesOn que restablezcan sus credenciales.

Después del inicio de sesión: 

a) Si permanece más de 1 hora sin actividad en el sistema, Karen, nuestra Gerente de Gestión de Sistemas y querida IA, lo desconectará automáticamente.
b) Si cierra la ventana del navegador, Karen también lo desconectará.
c) No es posible tener múltiples sesiones abiertas simultáneamente, Karen no lo permitirá.

APP para Android: 

Tenemos disponible la aplicación móvil para descarga en Google Play Store. Si tiene un celular o tableta Android, busque "EyesOn Asset" en la tienda y descargue la aplicación, iniciando sesión con las mismas credenciales que usa para la versión web.

a) Podrá ver la lista de auditorías que le han sido autorizadas.

b) Al seleccionar una auditoría, se desplegará la lista de verificación correspondiente.

c) Si usted es el auditor responsable, siga las instrucciones en cada sección para agregar fotos:

        Puede usar la aplicación para tomar las fotos o añadirlas desde su galería.

        Si toma las fotos con la aplicación, asegúrese de hacerlo en posición vertical; de lo contrario, las fotos aparecerán giradas.

        Para close-ups o fotos horizontales, se recomienda usar la cámara del celular y luego añadirlas desde la galería.

Para más información sobre cómo usar la aplicación, puede acceder al siguiente enlace: (link de instrucciones de la app).

¡Atención! Si no es el auditor responsable de la inspección física, podrá ver el informe en progreso, pero por favor, no añada fotos ni información por su cuenta.

Idioma: 

Puede elegir el idioma de los menús del sistema. En la aplicación web, diríjase a la esquina superior derecha, donde verá una pequeña flecha al lado de "Mi Perfil". Haga clic en la flecha y seleccione el idioma deseado.

¡Atención! Las listas de verificación y sus ítems permanecerán en el idioma en que fueron creados originalmente.

Ayuda/Soporte: 

Zeh Tork-Imeter es nuestro Director de Respuestas y nuestra IA más valorada. Él está disponible para proporcionar las mejores respuestas sobre el sistema (aunque no le recomendamos preguntar sobre temas filosóficos).

Si tiene alguna duda o consulta, haga clic en "Contacte a Zeh" o en "Centro de Ayuda" en la esquina superior derecha de la aplicación web, y envíe su inquietud, bug o sugerencia.

También puede añadir el número +1 805-912-8428 a su WhatsApp. Le recomendamos hacerlo. Por supuesto, si algo no funciona como debería, siempre puede ponerse en contacto con Shailon Ian, CEO de Mandatech, al correo shailon@vinciaero.com o por WhatsApp +55 11 944720605. Shailon no es un robot ni una IA.

Términos de Servicio y Política de Privacidad: 

En cualquier momento puede encontrar un enlace a nuestros Términos de Servicio y nuestra Política de Privacidad en la esquina inferior derecha de la página de inicio de sesión. Al iniciar sesión por primera vez, usted acepta ambos.`

export const LOCAL_STORAGE_INSPECTION_FILTER = 'inspection_filter'
export const LOCAL_STORAGE_INSPECTION_PAGE_NUMBER = 'audit-page'

export const EXPAND_SECTION_ACCORDEON_TEXT = t('See More')

export const MAX_RECORD_FILE_UPLOAD_CONCURRENCY_OPTIONS = [1, 3, 5, 10]
export const DEFAULT_MAX_RECORD_FILE_UPLOAD_CONCURRENCY = 1
